import { render, staticRenderFns } from "./ProspectCreateExternal.vue?vue&type=template&id=7b46e53e"
import script from "./ProspectCreateExternal.vue?vue&type=script&lang=ts"
export * from "./ProspectCreateExternal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports